import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import api from "../../../_metronic/helpers/api";
import { showAlert } from "../../redux/reducers/alertSlice";
import { stringify } from "qs";

function useUtils() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchAnnouncementT = async( limit=10, offset=0) => {
    const params = {
      limit,
      offset,
    };
    try {
      const response = await api.get(`/announcement-type?${stringify(params)}`);
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || "Network Error",
          variant: "danger",
        })
      );
    }
  };

  const updateDataOnly = async(values, mediaId=null) =>{
    try{
      let data = {
        type:values.type,
      }
      if(mediaId){
        data.mediaId = mediaId
      }
      const response = await api.patch(`announcement-type/${values.id}`, data)
      if (response.data.status) {
        dispatch(showAlert({message: 'Type updated', variant: 'success'}))
        navigate('/announcement-types')
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const updateWithNewMediaId = async(values)=> {
    try {
      const uniqueFileName = `file_${Date.now()}`;
      const imageFile = values.iconImage; 
      const fileType = imageFile.type; 
      const fileSize = `${imageFile.size}`; 

      const uploadDetails = {
        fileName: uniqueFileName,
        fileType: fileType,
        size: fileSize,
      };

      const uploadResponse = await api.post(
        "s3/upload-url",
        uploadDetails
      );

      const { mediaId, signedUrl } = uploadResponse.data.data;
  
      const imageUploadResponse = await axios.put(signedUrl, imageFile, {
        headers: {
         "Content-Type":fileType
        },
      });
      if (imageUploadResponse.status !== 200) {
        throw new Error("Image upload failed");
      }
      updateDataOnly(values, mediaId)
    } catch (error) {
      console.log("Error uploading image:", error, error.message);
    }
  }


  const submitAnnouncementType= async(values)=>{
    try {
      const uniqueFileName = `file_${Date.now()}`;
      const imageFile = values.iconImage; 
      const fileType = imageFile.type; 
      const fileSize = `${imageFile.size}`; 

      const uploadDetails = {
        fileName: uniqueFileName,
        fileType: fileType,
        size: fileSize,
      };

      const uploadResponse = await api.post(
        "s3/upload-url",
        uploadDetails
      );

      const { mediaId, signedUrl } = uploadResponse.data.data;
      
      const imageUploadResponse = await axios.put(signedUrl, imageFile, {
        headers: {
         "Content-Type":fileType
        },
      });
      if (imageUploadResponse.status !== 200) {
        throw new Error("Image upload failed");
      }
      createAnnounceType(values, mediaId)
    } catch (error) {
      console.log("Error uploading image:", error, error.message);
    }
  }

  const createAnnounceType=async(values, mediaId)=>{
    try {
      let data = {
        mediaId,
        type:values.type
      };  
      const response = await api.post(`/announcement-type`, data);
      if (response?.data?.status) {    
        dispatch(showAlert({message: 'Announcement Type Created', variant: 'success'}))
        navigate('/announcement-types')
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const deleteAnnouncementT= async (id,limit, offset ) => {
    try {
      const response = await api.delete(`/announcement-type/${id}`);
      if (response?.data?.status) {
        dispatch(
          showAlert({ message: "Successfully deleted", variant: "success", timeout: "1000" })
        );
        return fetchAnnouncementT(limit, offset);
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: "danger",

        })
      );
    }
  };

  const onEdit = async (id) => {
    try {
      const response = await api.get(
        '/announcement-type/'+id
      );
      if (response.data.status) {
        return response.data.data;
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message,
          variant: "danger",
        })
      );
    }
  };

  return {
    fetchAnnouncementT,
    updateDataOnly,
    updateWithNewMediaId,
    submitAnnouncementType,
    deleteAnnouncementT,
    onEdit
  };
}

export default useUtils;
